import React from 'react';
export const Footer = () => {
  return <footer className="bg-charcoal text-gray-400 py-8 md:py-12" data-id="element-121">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-122">
        <h2 className="text-2xl md:text-3xl font-bold text-white font-playfair mb-2 md:mb-4" data-id="element-123">
          🧘‍♀️ PILATES 360™
        </h2>
        <p className="text-sm md:text-lg text-gray-300 mb-1 md:mb-2" data-id="element-124">
          El sistema de clases N°1 para instructoras de Pilates en Argentina.
        </p>
        <p className="text-xs md:text-sm italic mb-8 md:mb-12" data-id="element-125">
          Porque enseñar Pilates no debería costarte todas las noches de la
          semana.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-3 md:gap-6 mb-8 md:mb-12 text-xs md:text-sm" data-id="element-126">
          <a href="mailto:contacto@rincondocente360.com" className="hover:text-white transition-colors" data-id="element-127">
            📧 contacto@rincondocente360.com
          </a>
          <span className="hidden md:inline" data-id="element-128">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-129">
            📲 @rincondocente360
          </a>
          <span className="hidden md:inline" data-id="element-130">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-131">
            🌐 pilates.rincondocente360.com
          </a>
        </div>

        <div className="border-t border-gray-700 pt-6 md:pt-8 text-[10px] md:text-xs" data-id="element-132">
          <p data-id="element-133">© RinconDocente360™ 2026 — Todos los derechos reservados.</p>
          <p className="mt-1 md:mt-2" data-id="element-134">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
};